export default "__VITE_ASSET__V5oGwcAp__"